import { render, staticRenderFns } from "./promotion_seckill_item.vue?vue&type=template&id=384654c0&scoped=true&"
import script from "./promotion_seckill_item.vue?vue&type=script&lang=ts&"
export * from "./promotion_seckill_item.vue?vue&type=script&lang=ts&"
import style0 from "./promotion_seckill_item.vue?vue&type=style&index=0&id=384654c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384654c0",
  null
  
)

export default component.exports